const {h, render, Component} = require('preact');

class ClaimPayment extends Component {
  constructor(props) {
    super(props);
  }

  getClaimPayment() {
    if (this.props.claimDetails && this.props.claimDetails.isPayToClaim && this.props.claimDetails.price){
      return this.props.claimDetails.price
    }
    return null;
  }

  render() {
    let payment = this.getClaimPayment()
    if (payment){
      return (
        <tr>
          <td>{I18n.translate("js.modules.web_2018.claim_payment")}:</td>
          <td>{payment}</td>
        </tr>
      );
    }
    return null;
  }
}

module.exports = ClaimPayment
